import { useEffect, useState } from "react";
import {
  DEV_IMPERSONATION_EVENT,
  DEV_IMPERSONATION_STORAGE_KEY,
  readDevImpersonation,
  type DevImpersonationV1,
} from "@/lib/devImpersonationStorage";

/** Re-renders when dev impersonation localStorage changes (same tab or storage event). */
export function useDevImpersonationStorage(): DevImpersonationV1 {
  const [snap, setSnap] = useState<DevImpersonationV1>(() => readDevImpersonation());

  useEffect(() => {
    const apply = () => setSnap(readDevImpersonation());
    apply();
    window.addEventListener(DEV_IMPERSONATION_EVENT, apply);
    const onStorage = (e: StorageEvent) => {
      if (e.key === null || e.key === DEV_IMPERSONATION_STORAGE_KEY) apply();
    };
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(DEV_IMPERSONATION_EVENT, apply);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return snap;
}
